import { render, staticRenderFns } from "./balanceRechargeRecordss.vue?vue&type=template&id=27c928d0&scoped=true&"
import script from "./balanceRechargeRecordss.vue?vue&type=script&lang=js&"
export * from "./balanceRechargeRecordss.vue?vue&type=script&lang=js&"
import style0 from "./balanceRechargeRecordss.vue?vue&type=style&index=0&id=27c928d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c928d0",
  null
  
)

export default component.exports